import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const BoxMessage = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.9rem 0.8rem;
  border-radius: 0.4rem;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`